<template>
  <div id="app">
    <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">{{ title }}</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container" v-html="Body"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      title: '',
      Body: '',
    }
  },
  components: { HomeHeader },
  mounted() {
    this.id = this.$route.query.ItemId
    this.GetList()
  },
  watch: {
    $route(to, from) {
      if (to.query.ItemId !== from.query.ItemId) {
        this.id = to.query.ItemId
        this.GetList()
      }
    },
  },
  methods: {
    GetList() {
      this.$store.dispatch('_getHeader', [parseInt(this.id)]).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.title = res.data.Data[0].Title
            this.Body = res.data.Data[0].Body
            document.title = this.title
          }
        }
      })
    },
  },
}
</script>

<style scoped></style>
